import StoresControl from './StoresControl';
import environment from '../environment';

export class StorePlannedControl extends StoresControl {
  constructor () {
    const options = {
      name: 'StorePlanned',
      context: 'LAYER_PLANNED_STORES',
    };

    super(options);
  }

  static getInstance () {
    if (!StorePlannedControl._instance) {
      StorePlannedControl._instance = new StorePlannedControl();
    }

    return StorePlannedControl._instance;
  }
}

export default StorePlannedControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/StorePlannedControl.js